module.exports = "/packs/images/navigation/refer-smoker-c081f6018af6070cf9fe83bc380c4441.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/refer-smoker.jpg
// module id = 1814
// module chunks = 0